var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollapse(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 14,
    rx: 1.5,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11h22v7H1v-7z",
    fill: "#000",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.707 10.293a1 1 0 010 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414L12 12.586l2.293-2.293a1 1 0 011.414 0z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iNSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjE0IiByeD0iMS41IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0xIDExSDIzVjE4SDFWMTFaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjE1Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUuNzA3MSAxMC4yOTI4QzE2LjA5NzYgMTAuNjgzNCAxNi4wOTc2IDExLjMxNjUgMTUuNzA3MSAxMS43MDdMMTIuNzA3MiAxNC43MDY5QzEyLjMxNjYgMTUuMDk3NSAxMS42ODM1IDE1LjA5NzUgMTEuMjkzIDE0LjcwNjlMOC4yOTI5NiAxMS43MDcxQzcuOTAyNDMgMTEuMzE2NSA3LjkwMjQyIDEwLjY4MzQgOC4yOTI5NCAxMC4yOTI4QzguNjgzNDUgOS45MDIzMiA5LjMxNjYyIDkuOTAyMyA5LjcwNzE1IDEwLjI5MjhMMTIgMTIuNTg1NkwxNC4yOTI4IDEwLjI5MjhDMTQuNjgzNCA5LjkwMjMxIDE1LjMxNjUgOS45MDIzMSAxNS43MDcxIDEwLjI5MjhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };